/* ff-cart-drawer – Reservierungs-Countdown + Header-Zähler für den feelfem Cart-Drawer.
   Dawn rendert Teile des Drawers über die Section Rendering API neu; deshalb beobachtet dieses Skript
   <cart-drawer> per MutationObserver und liest den Stand aus cart-drawer-items[data-ff-count]. */
(function () {
  var KEY = 'ff_cart_timer_start';

  function readStart() {
    try { return parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; }
  }
  function writeStart(value) {
    try {
      if (value === null) sessionStorage.removeItem(KEY);
      else sessionStorage.setItem(KEY, String(value));
    } catch (e) { /* kein Storage verfügbar */ }
  }

  var memoryStart = 0;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var timers = document.querySelectorAll('[data-ff-timer]');
    if (!timers.length) return;
    var start = readStart() || memoryStart;
    if (!start) {
      start = Date.now();
      memoryStart = start;
      writeStart(start);
    }
    for (var i = 0; i < timers.length; i++) {
      var el = timers[i];
      var minutes = parseFloat(el.getAttribute('data-ff-minutes')) || 5;
      var remaining = Math.max(0, Math.round(minutes * 60 - (Date.now() - start) / 1000));
      var display = el.querySelector('[data-ff-timer-display]');
      if (display) display.textContent = pad(Math.floor(remaining / 60)) + ':' + pad(remaining % 60);
    }
  }

  function sync() {
    var items = document.querySelector('cart-drawer-items');
    var count = items ? parseInt(items.getAttribute('data-ff-count') || '0', 10) || 0 : 0;
    var counters = document.querySelectorAll('[data-ff-cart-count]');
    for (var i = 0; i < counters.length; i++) counters[i].textContent = count;
    if (count === 0) {
      writeStart(null);
      memoryStart = 0;
    }
    tick();
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    sync();
    if ('MutationObserver' in window) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) return;
        pending = requestAnimationFrame(function () { pending = null; sync(); });
      }).observe(drawer, { childList: true, subtree: true });
    }
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
